import { InputDescription, InputName } from "@components-common/forms";
import { FC } from "react";
import { Col } from "taltech-styleguide";
import { WallLayerRadioSelector } from "../WallLayerSelector";
import { useLocation } from "react-router-dom";

/**
 * Functional Component: ComponentTypeDataForm
 *
 * This component renders a form for component type data. It includes input fields for name and description,
 * and conditionally includes a wall layer radio selector if the pathname contains "walls".
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the form for component type data.
 */
export const ComponentTypeDataForm: FC = () => {
  const { pathname } = useLocation();

  return (
    <div className="mt-3">
      <Col xs="4">
        <InputName  elementClass="required" />
      </Col>
      <Col xs="4">
        {pathname.includes("walls") && <WallLayerRadioSelector />}
      </Col>
      <Col xs="7" className="mt-2">
        <InputDescription />
      </Col>
    </div>
  );
};
